import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-label-type-one',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './label-type-one.component.html',
    styleUrl: './label-type-one.component.css'
})
export class LabelTypeOneComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;

  getDisplayName(fields: any) {
    let name = fields.displayName;
    if (fields.domain) {
      name = name.replace(/{{\s*domain\s*}}/g, fields.domain);
    }

    return name;
  }
}
